import { DropdownProps } from 'antd';
// eslint-disable-next-line no-restricted-imports
import { Dropdown as AntDropdown } from 'antd';
import React from 'react';

export interface IDropdownProps extends DropdownProps {}

/**
 * Dropdown modificato per supportare gli attributi ARIA
 */
export function Dropdown(props: IDropdownProps) {
  const { ...otherProps } = props;

  return <AntDropdown trigger={['click']} autoFocus {...otherProps} />;
}
